import { paths } from 'src/routes/paths';

import { CONFIG } from 'src/global-config';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

export const navData = [
  { title: 'Home', path: '/', icon: <Iconify width={22} icon="solar:home-2-bold-duotone" /> },
  { title: 'About Us', path: paths.about },
  // {
  //   title: 'Components',
  //   path: paths.components,
  //   icon: <Iconify width={22} icon="solar:atom-bold-duotone" />,
  // },
  {
    title: 'ORION',
    path: '/pages',
    icon: <Iconify width={22} icon="solar:file-bold-duotone" />,
    children: [
      {
        subheader: 'Features',
        items: [
          { title: 'Therapist Directory', path: paths.therapistDirectory },
          { title: 'Self Assessments', path: paths.selfAssessments },
        ],
      },
      {
        subheader: 'Alpha Release',
        items: [
          { title: 'Data Security & Privacy', path: paths.alphaRelease },
          // { title: 'Data Security & Privacy', path: paths.product.root },
        ],
      },
      { subheader: 'Dashboard', items: [{ title: 'Dashboard', path: CONFIG.auth.redirectPath }] },
    ],
  },
];
